// Publishes the current entity's display name to the breadcrumb trail (firm, deal, result, bank).
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCrumbEntityStore } from '@/store/crumbEntityStore';

export function useCrumbEntity(label: string | null | undefined): void {
  const { pathname } = useLocation();
  const setEntity = useCrumbEntityStore((s) => s.setEntity);

  useEffect(() => {
    setEntity(pathname, label ?? null);
    return () => setEntity(pathname, null);
  }, [pathname, label, setEntity]);
}
